module.exports = __webpack_public_path__ + "img/redis.f6641f3c.svg";